<div [ngClass]="{ 'base-layout': true, 'base-layout-dark': darkMode }">
  <div class="base-layout-header" *ngIf="showHeader">
    <img alt="logo" class="brand-logo logo-intro" style="content: var(--logo-intro)" *ngIf="!darkMode" />
    <img alt="logo" class="brand-logo" style="content: var(--logo-form-light)" *ngIf="darkMode" />
  </div>

  <div class="base-layout-content">
    <ng-content></ng-content>
  </div>

  <div class="base-layout-footer" *ngIf="showFooter">
    <!-- <app-time-line-step>
    </app-time-line-step> -->
    <!-- <app-progress-bar
      class="base-layout-footer-progress-bar"
    ></app-progress-bar> -->
  </div>

  <div
    [ngClass]="{
      'base-layout-copyright': true,
      'base-layout-copyright-dark': darkMode
    }"
  >
    © {{ year }} Esphero. Todos os direitos reservados. v{{ version }}
  </div>
</div>
